export function errorMessage(name: string): string {
  if (name.includes(' ')) return 'Tags cannot contain spaces'
  if (name.length > 256) return 'Tags cannot be longer than 256 characters'
  return ''
}
